/**
 * @Des 组件 基站组
 * @Description
 * @Author
 * @Date 2025/11/4
 */
/* HTML */
<template>
	<section style="height: 100%;overflow: hidden;background-color: rgba(3, 11, 24, 0.87);">

		<!-- 加载中 -->
		<div :class="{'none-map-item': true, 'off': flags.falg_AMap_inited}">
			<img alt="加载中" v-show="!flags.falg_AMap_inited" title="加载中" src="@/static_dazzle/images/loading_1.gif">
		</div>

		<!-- 地图 容器 -->
		<div id="mapItem_track" class="view-amap-box" @contextmenu.prevent="onContextmenu" style="height: 100%;width: 100%;text-align: left;"></div>

		<!-- 区域 快捷列表 start -->
		<div :class="{'area-items-box': true, 'roll-call-on': false}" v-show="areas.length > 0" style="top: 40px;left: 30px;">
			<ul>
				<li v-for="(item, index) in areas" :key="index" :class="{'on': false}" :title="item.label" @click="clickAreaRow(item)">{{item.label}}</li>
				<li v-if="this.$checkEmpty(areas)" title="暂无区域">暂无区域</li>
			</ul>
		</div>
		<!-- 区域 快捷列表 end -->

	</section>
</template>

/* JS */
<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable';
	// 公共方法
	import GlobalFun from '@/global/global-function';
	import { mapGPSGaode } from '@/static_dazzle/plugins/amap/map_gps_gaode';

	// API 组织结构
	import ApiOam from "@/request/api-oam";

	export default {
		name: "OutdoorTrackMap",
		props: {
			/**
			 * @Des 展示box
			 * @Auth
			 * @Date 2025/11/4
			 */
			showTreeBoxFlag: {
				type: Boolean,
				default: function() {
					return true
				}
			},
			/**
			 * @Des 轨迹数据
			 * @Auth
			 * @Date 2025/11/4
			 */
			trackObj: {
				type: Object,
				default: function() {
					return {}
				}
			},
			/**
			 * @Des 轨迹数据
			 * @Auth
			 * @Date 2025/11/4
			 */
			trackInfos: {
				type: Array,
				default: function() {
					return []
				}
			},
			/**
			 * @Des 时间差值 ms
			 * @Auth
			 * @Date 2025/11/4
			 */
			timeDiff: {
				type: Number,
				default: function() {
					return 1000
				}
			},

		},
		/**
		 * @Des 组件引用
		 * @Auth
		 * @Date 2025/11/4
		 */
		components: {

		},
		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 2025/11/4
		 */
		data() {
			return {
				// 地图 组件
				mapFn: new mapGPSGaode(),
				// 定位方式
				positionModes: {
					1: 'GPS',
					2: 'WIFI',
					3: 'LBS',
					5: 'PHONE',
					6: 'BD',
					7: 'GN'
				}, // positionModes
				// 室内地图 组织结构
				organizations: [],
				// 室内地图 区域
				areas: [],
				// 缓存  记录 轨迹信息
				map_track: new this.HashMap(),
				// 轨迹点 数量
				trackPointsLength: 0,

				// flags
				flags: {
					falg_AMap_inited: false, // flag AMap 已加载
				}, // flags

				// icons
				iocns: {
					start: '/static/images/map/outdoorIocns/icon-point-start.png', // 起始图元
					end: '/static/images/map/outdoorIocns/icon-point-end.png', // 结束图元
					direction: '/static/images/map/outdoorIocns/icon-point-direction.png', // 方向图元
				}, // iocns

			} // return
		}, // data()
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 2025/11/4
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			// 到这
			window.goToHere = this.goToHere;

			// 初始化 地图
			this.initMap();
		}, // mounted
		/**
		 * @Des 加载
		 * @Auth
		 * @Date 2025/11/4
		 */
		created() {

		}, // created
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 2025/11/4
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 到这
			window.goToHere = null;

			// 销毁地图
			this.mapFn.destroyMap();

		}, // beforeDestroy
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 2025/11/4
		 */
		destroyed() {

		}, // destroyed
		methods: {

			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date 2025/11/4
			 */
			startSubscribes() {

			}, // startSubscribes
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date 2025/11/4
			 */
			endSubscribes() {

			}, // endSubscribes
			//========================== 订阅消息 end ==========================

			/**
			 * @Des 查询 组织结构
			 * @Auth
			 * @Date 2025/11/4
			 */
			searchOrg() {
				return false;
				this.$request.postJsonRequest(ApiOam.Find_Org_Uri, {
					projectId: this.$store.state.currentProjectId
				}).then(result => {
					// 室内地图 组织结构
					this.organizations = Object.assign([], []);
					// 室内地图 区域
					let areas = [];
					// console.log(result);
					if(result.code == 0 && result.data && result.data.length > 0) {
						result.data.forEach((row, index) => {
							row.label = row.name;
							if(row.level == 1) {
								row.label += "（" + row.parentNode.appName + "）";
							} else if(row.level == 2) {
								if(row.project.hasArea == 1) {
									row.label; // += "（区域）";
									areas.push(Object.assign({}, row));
								} else {
									row.label; // += "（地图）";
								}
							} else if(row.level == 3) {
								row.label; // += "（地图）";
							}
						})
						// 室内地图 区域
						this.areas = Object.assign([], areas);
						// 室内地图 组织结构
						this.organizations = GlobalFun.dataToTree(Object.assign([], result.data), {
							id: 'id',
							pid: 'parentId',
							children: 'children',
							label: 'label',
							node: 'node',
							parentNode: 'parentNode',
							project: 'project',
						});
						// console.log(Object.assign([], this.organizations));
					}
					// 添加 旗帜
					this.addFlagMarkers();
				}).catch(error => {
					console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
					// 加载 组织结构 flag
					this.orgLoadingFlag = false;
				})
			}, // searchOrg

			/**
			 * @Des 初始化 地图
			 * @Auth
			 * @Date 2025/11/4
			 */
			async initMap() {
				// 地图 组件
				await this.mapFn.initMap('mapItem_track', {
					// 地图类型
					mapStyle: 'amap://styles/blue',
				}, (AMap) => {
					// flag AMap 已加载
					this.flags.falg_AMap_inited = true;

					// 初始化 地图附属
					this.initMapLayers();
				});
			}, // initMap

			/**
			 * @Des 初始化 地图附属
			 * @Auth
			 * @Date 2025/11/4
			 */
			initMapLayers() {

				// 设置 中心 级别
				// this.mapFn.setZoomAndCenter(10, [117.26235481181146, 36.751024895966464]);

				// 添加 自定义地图
				this.addImageLayer();

				// 查询 组织结构
				// this.searchOrg();

				// 接收轨迹数据
				this.receiveTrackData({
					user: this.trackObj,
					positionList: this.trackInfos
				});

			}, // initMapLayers

			/**
			 * @Des 添加 自定义地图
			 * @Auth
			 * @Date 2025/11/4
			 */
			addImageLayer() {
				// 创建 覆盖物 image
				this.mapFn.creatImageLayer({
					name: '智慧工厂',
					url: '/static/images/map/mapLayers/jg-gongdi-001.png', // 修改为你自己的图片链接
					bounds: [
						[117.261354, 36.751667], // 图片左下角经纬度坐标
						[117.263744, 36.750307] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
					],
					zIndex: 20, // 设置覆盖物的层级
					opacity: 1, // 设置覆盖物的透明度
				}); // creatImageLayer
			}, // addImageLayer

			/**
			 * @Des 添加 旗帜
			 * @Auth
			 * @Date 2025/11/4
			 */
			// 添加 旗帜
			addFlagMarkers() {
				// 项目
				let projectRow = Object.assign({}, this.organizations[0]);
				// 空值 中止
				if(this.$checkEmpty(projectRow)) return false;

				// 区域
				let areaRows = Object.assign([], projectRow.children);
				Object.assign([], areaRows).forEach((row, index) => {
					// 非区域 跳过
					if(row.level != 2) return true;
					let areaNode = Object.assign({}, row.node);
					// 空值 跳过
					if(this.$checkEmpty(areaNode)) return true;

					// Icon 旗帜
					let flagIcon = this.mapFn.creatIcon({
						size: [60, 60],
						imageSize: [60, 60],
						icon: '/static/images/map/outdoorIocns/iocn-flag.webp'
					});

					let flagDid = ['flagMarker', areaNode.areaId].join('_');
					// Marker 旗帜
					let flagMarker = this.mapFn.creatMarker({
						position: [areaNode.startPointX, areaNode.startPointY], // [117.263698, 36.750353] // 红旗所在的经纬度坐标
						offset: [28, -32], // 将红旗位置上移一些，使其正好位于覆盖物左上角
						icon: flagIcon,
						extData: {
							"markerID": flagDid,
							"markerItem": Object.assign({}, row, {
								did: flagDid
							})
						},
						zIndex: 30, // 设置比覆盖物更高的层级
						clickMarker: this.clickFlagMarker,
						// rightClickMarker: this.rightClickFlag
					});
					// 将标记对象添加到地图上
					this.mapFn.addMarker(flagDid, flagMarker);

				});
			}, // addFlagMarkers
			/**
			 * @Des 点击 旗帜
			 * @Auth
			 * @Date 2025/11/4
			 */
			clickFlagMarker(e) {
				return false;
				e = e || event;
				let extData = e.target.getExtData();

				let markerItem = Object.assign({}, extData.markerItem);
				let areaRow = Object.assign({}, markerItem.node);
				// 空值 中止
				if(this.$checkEmpty(areaRow) || this.$checkEmpty(markerItem.children)) return false;

				// 地图
				let mapRows = Object.assign([], markerItem.children);
				let mapRow = {};
				mapRows.forEach((row, index) => {
					// 已有值 跳过
					if(!this.$checkEmpty(mapRow)) return true;
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.node)) return true;
					mapRows = Object.assign({}, row.node);
				});

				// 路由 跳转
				this.$router.replace({
					path: '/manager/location/monitor',
					query: {
						areaId: areaRow.areaId,
						mapId: mapRow.mapId
					}
				}, () => {}, () => {});
			}, // clickFlagMarker

			/**
			 * @Des 绘制 图元
			 * @Auth
			 * @Date 2025/11/4
			 */
			drawMarker(info) {
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.didName || info.did.substring(info.did.length - 4),
						// content:'手牵手',
						direction: "top",
						offset: [-10, 0],
					},
					offset: [0, 0],
					position: [parseFloat(info.lng_Gc), parseFloat(info.lat_Gc)],
					icon: !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {
						"markerID": info.did,
						"markerItem": info
					},

				});
				marker.content = this.initMarkerContent(info);

				// 添加 marker
				this.mapFn.addMarker(info.did, marker);

			}, // drawMarker
			/**
			 * @Des 移除 图元
			 * @Auth
			 * @Date 2025/11/4
			 */
			removeMarker(did) {
				// 添加 marker
				this.mapFn.removeMarker(did);
			},

			/**
			 * @Des 图元 content
			 * @Auth
			 * @Date 2025/11/4
			 */
			initMarkerContent(item) {
				let alarmHtmls = [];
				Object.assign([], item.alarms).forEach((row, index) => {
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.alarmName) || this.$checkEmpty(row.time)) return true;
					alarmHtmls.push('<span style="color: #2700ff">' + row.alarmName + '  ' + this.$moment(row.time).format('YYYY-MM-DD HH:mm:ss') + '</span>');
				});
				let alarmsHtml = alarmHtmls.length > 0 ? ['<label style="color:#000000"><span style="float: left;">报警信息:</span><p style="color: #2700ff;padding-left: 56px;">', alarmHtmls.join('<br>'), '</p></label></p>'].join('') : '';
				
				let _content = `
				<div class="map-info-content-box" style="background-color: #fff;font-size: small;border-radius: 10px;opacity: 0.9;padding: 10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,1);">
					<div style="text-align: center;">
						<h4 style="font-weight: bold; line-height: 30px;color: #000;">` + item.did + `<span style="padding-left: 10px;">( ` + (item.index + 1) + " / " + item.max + ` )</span><button style="padding: 0.1rem 0.5rem;transform: scale(0.8);float: right;" type="button" class="button-custom-1" onclick="goToHere('` + [parseFloat(item.lng_gc), parseFloat(item.lat_gc)] + `','` + item.did + `')"><i class="el-icon-position"></i><span style="padding-left: 5px;">到这</span></button></h4>
					</div>
					<div className="custom-infowindow input-card" style="z-index:999999999999;">
						<label style="color:#000000">气压:  <span style='color: #2700ff'>` + item.air + "帕" + ` </span></label></p>
						<label style="color:#000000">高度:  <span style='color: #2700ff'>` + item.relative_altitude + "米" + `</span></label></p>
						<label style="color:#000000">定位方式：<span style='color: #2700ff'>` + this.positionModes[item.position_mode] + `</span></label></p>
						<label style="color:#000000">剩余电量：<span style='color: #2700ff'>` + item.power + "%" + ` </span></label></p>
						<label style="color:#000000">运行速度：<span style='color: #2700ff'>` + (parseFloat(item.speed) * 3600 / 1000) + ` km/h</span></label></p>
						<label style="color:#000000">地理位置：<span style='color: #2700ff'>` + item.address + ` </span></label></p>
						` + alarmsHtml + `
						<label style="color:#000000">更新时间：<span style='color: #2700ff'>` + this.$moment(item.upload_time).format('YYYY-MM-DD HH:mm:ss') + `</span></label></p>
					</div>
				</div>`;
				
				return _content;
			}, // initMarkerContent
			/**
			 * @Des 图元 title
			 * @Auth
			 * @Date 2025/11/4
			 */
			initMarkerTitle(info) {
				// "电量: " + info.power + "%",
				let title = [
					"轨迹 " + " DID: " + (info.did) + "（" + (info.index + 1) + "/" + (info.max) + "）",
					"气压: " + info.air + " 帕",
					"高度: " + info.relative_altitude + " 米",
					"定位方式: " + this.positionModes[info.position_mode],
					"剩余电量: " + info.power + " %",
					"运行速度: " + (parseFloat(info.speed) * 3600 / 1000),
					"地理位置: " + info.address,
					"更新时间: " + this.$moment(info.upload_time).format('YYYY-MM-DD HH:mm:ss')
				].join('\n');
				return title;
			}, // initMarkerTitle
			/**
			 * @Des 到这
			 * @Auth
			 * @Date 2025/11/4
			 */
			goToHere(lnglat, did) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;

				this.mapFn.setZoomAndCenter(18, lnglat.split(','));
				this.mapFn.setZoom(20);
			}, // goToHere

			// ======================================================= 快捷列表 start ======================================================= //
			/**
			 * @Des 事件 区域列表
			 * @Auth
			 * @Date 2025/11/4
			 */
			clickAreaRow(row) {
				// 空值 跳过
				if(this.$checkEmpty(row) || this.$checkEmpty(row.node)) return false;
				let item = Object.assign({}, row.node);

				// this.mapFn.setZoom(8);
				// this.mapFn.setCenter([item.startPointX, item.startPointY]);
				this.mapFn.setZoomAndCenter(8, [item.startPointX, item.startPointY]);
				this.mapFn.setZoom(10);
			}, // clickAreaRow
			// ======================================================= 快捷列表 end ======================================================= //

			// ======================================================= 解析轨迹 start ======================================================= //
			/**
			 * @Des 接收数据
			 * @Auth
			 * @Date 2025/11/4
			 */
			receiveTrackData(data) {
				// 轨迹数据
				this.trackInfo = Object.assign({}, data);
				let user = data.user;
				let positionList = data.positionList;
				let did = '';
				positionList.forEach((row, index) => {
					row.index = index;
					row.max = positionList.length;
					if(!did) {
						did = row.did || row.tagId;
					}
				});

				// 轨迹点 数量
				this.trackPointsLength = positionList.length;

				this.map_track.put(user.userId, {
					bindingType: 1,
					userName: user.userName,
					no: user.userNo,
					typeId: user.typeId,
					type: (user.typeId ? user.typeId : 1),
					groupId: user.groupId,
					rows: Object.assign([], positionList),
					color: this.mapFn.getColor(), // 获取随机色
					did: did,
					max: positionList.length,
				});

				// 解析数据
				this.analysisTracks();
			}, // receiveTrackData
			/**
			 * @Des 解析数据
			 * @Auth
			 * @Date 2025/11/4
			 */
			analysisTracks() {
				if(this.map_track.size() == 0) {
					// 没有轨迹数据
					return;
				}

				let polylines = []; // 记录 polylines
				let markers = []; // 记录 markers
				let massMarkers = []; // 记录 海量点
				var hasNoPoints = true;
				// 根据 开始时间、结束时间 以及 坐标点集合时间范围 进行前后补点
				this.map_track.keySet().forEach((key, n) => {
					var row = this.map_track.get(key);
					// 空值 中止
					if(this.$checkEmpty(row) || this.$checkEmpty(row.rows)) return false;
					row.lineIndex = n;

					// 非空值
					if(hasNoPoints) {
						hasNoPoints = false;
					}

					let startMarker, endMarker;
					let polyPoints = []; // 记录 线段 点
					let rows = row.rows;
					rows.forEach((r, i) => {
						// 起始、结束 角度为0
						if(i == 0 || i == rows.length - 1) {
							r.angle = 0;
						} else {
							let nextRow = Object.assign({}, rows[i + 1]);
							// 计算角度
							let angle = this.mapFn.latLngAngle([nextRow.lat_Gc, nextRow.lng_Gc], [r.lat_Gc, r.lng_Gc]);
							r.markerAngle = angle;
						}

						// 记录 线段 点
						polyPoints.push([r.lng_Gc, r.lat_Gc]);

						// 轨迹点 数量
						if(this.trackPointsLength <= 500) {
							if(i == 0) {
								startMarker = this.creatMarker(Object.assign({}, r));
							} else if(i == rows.length - 1) {
								endMarker = this.creatMarker(Object.assign({}, r));
							} else {
								// 创建图元
								let marker = this.creatMarker(Object.assign({}, r));
								// 记录 markers
								markers.push(marker);
							}
						} else {
							// 轨迹点 > 500 海量点

							// 创建 海量点
							let massMarker = this.creatMassMarker(Object.assign({}, r));
							// 记录 海量点
							massMarkers.push(massMarker);
						}

					});

					// 轨迹点 数量
					if(this.trackPointsLength <= 500) {
						// 记录 markers
						markers.push(startMarker);
						markers.push(endMarker);
					}

					// 创建 polyline
					let polyline = this.mapFn.creatPolyline({
						path: polyPoints,
						showDir: true,
						dirColor: 'pink',
						strokeColor: row.color,
						strokeOpacity: 0.5,
						strokeWeight: 7,
						lineJoin: "round",
						lineCap: "round",
						extData: {
							"polyID": row.did,
							"max": row.max,
							"point": (n + 1),
						},
					});
					// 记录 polylines
					polylines.push(polyline);
				});

				//空值 中止
				if(hasNoPoints) {
					//$('.palyerBox').hide();
					this.$message({
						message: '暂无相关轨迹！',
						type: 'warning',
						showClose: true,
						dangerouslyUseHTMLString: true
					});
					return false;
				}

				// 绘制轨迹线
				this.drawPolylines(polylines);

				// 轨迹点 数量
				if(this.trackPointsLength <= 500) {
					// 绘制轨迹 点
					this.drawMarkers(markers);
				} else {
					// 绘制轨迹 点 海量点
					this.drawMassMarkers(massMarkers)
				}

				// 设置合适视图
				this.mapFn.setFitView();

			}, // analysisTracks
			/**
			 * @Des 绘制轨迹线
			 * @Auth
			 * @Date 2025/11/4
			 */
			drawPolylines(polylines) {
				// 添加 polylines
				this.mapFn.addPolylines(polylines);
			}, // drawPolylines

			/**
			 * @Des 图元匹配
			 * @Auth
			 * @Date 2025/11/4
			 */
			matchMarkerIcon(info) {
				// 只有一个点 || 结束点
				if(info.max == 1 || info.index == info.max - 1) {
					return this.mapFn.creatIcon({
						size: [40, 60],
						imageSize: [40, 60],
						icon: this.iocns['end']
					});
				}

				// 起始点
				if(info.index == 0) {
					return this.mapFn.creatIcon({
						size: [40, 60],
						imageSize: [40, 60],
						icon: this.iocns['start']
					});
				}

				// 方向图元
				return this.mapFn.creatIcon({
					size: [32, 32],
					imageSize: [32, 32],
					icon: this.iocns['direction']
				});
			}, // matchMarkerIcon
			/**
			 * @Des 创建图元
			 * @Auth
			 * @Date 2025/11/4
			 */
			creatMarker(info) {
				// 起始、结束 偏移
				let offset = info.index == 0 || info.index == (info.max - 1) ? [0, -20] : [0, 0];
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					title: this.initMarkerTitle(info),
					offset: offset,
					position: [parseFloat(info.lng_Gc), parseFloat(info.lat_Gc)],
					icon: this.matchMarkerIcon(Object.assign({}, info)),
					angle: info.markerAngle,
					extData: {
						"markerID": [info.did, info.index].join('_'),
						"markerItem": info
					},
				});
				marker.content = this.initMarkerContent(info);
				return marker;
			}, // creatMarker
			/**
			 * @Des 绘制轨迹 点
			 * @Auth
			 * @Date 2025/11/4
			 */
			drawMarkers(markers) {
				// 添加 markers
				this.mapFn.addMarkers(markers);
			}, // drawMarkers

			/**
			 * @Des 创建 海量点
			 * @Auth
			 * @Date 2025/11/4
			 */
			creatMassMarker(info) {
				// 创建 marker
				let massMarker = this.mapFn.creatMassMarker({
					lnglat: [info.lng_Gc, info.lat_Gc],
					title: this.initMarkerTitle(info),
					markerID: [info.did, info.index].join('_'),
					uploadTime: this.$moment(info.upload_time).format('YYYY-MM-DD HH:mm:ss'),
					point: (info.index + 1) + "/" + (info.max),
					extData: {
						"markerID": [info.did, info.index].join('_'),
						"markerItem": info
					},
					myContent: this.initMarkerContent(info)
				});
				return massMarker;
			}, // creatMassMarker
			/**
			 * @Des 绘制轨迹 点 海量点
			 * @Auth
			 * @Date 2025/11/4
			 */
			drawMassMarkers(massMarkers) {
				// 创建海量点
				this.mapFn.creatMassMarks(massMarkers);
			}, // drawMarkers
			// ======================================================= 解析轨迹 end ======================================================= //

		}, // methods
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 2025/11/4
		 */
		watch: {

		}, // watch

	}
</script>

/* CSS */
<style lang="scss" scoped>
	* {
		box-sizing: border-box;
		color: #e6e6e6;
	}
	
	.area-items-box,
	.map-items-box {
		ul {
			background-color: #034178;
			/*border-image: linear-gradient(90deg, #0A9AFB, #0A9AFB, #0A9AFB) 1 1;*/
			li {
				width: auto;
				min-width: max-content;
				max-width: 200px;
				background-color: #061b3d;
				color: #e9eaeb;
				&:hover {
					border-color: #4681bf;
				}
			}
		}
		/* ul */
	}
	/* area-items-box map-items-box */
</style>


// WEBPACK FOOTER //
// src/components_outdoor/Outdoor/OutdoorTrackMap.vue